<template>
  <svg
    height="40"
    width="40"
    style="color: #6154A4"
    viewBox="0 0 100 100"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path fill="#000000" d="M 100.00,82.99 L 81.04,82.99 C 79.64,82.99 78.51,82.65 77.64,81.97 C 76.77,81.30 76.08,80.49 75.57,79.56 L 63.80,59.32 C 63.58,60.04 63.33,60.72 63.03,61.36 C 62.74,61.99 62.42,62.59 62.08,63.14 L 52.41,79.56 C 51.81,80.41 51.11,81.19 50.31,81.91 C 49.50,82.63 48.46,82.99 47.19,82.99 L 29.63,82.99 L 51.77,48.89 L 30.52,17.01 L 49.48,17.01 C 50.88,17.01 51.91,17.19 52.57,17.55 C 53.22,17.91 53.81,18.51 54.32,19.36 L 66.09,38.90 C 66.34,38.13 66.66,37.38 67.04,36.64 C 67.42,35.90 67.85,35.14 68.31,34.38 L 76.71,19.68 C 77.31,18.75 77.93,18.07 78.59,17.64 C 79.25,17.22 80.06,17.01 81.04,17.01 L 99.11,17.01 L 77.86,48.00 Z"/>
    <path fill="currentColor" d="M 71.28,47.53 L 62.07,63.14 L 52.40,79.56 C 51.89,80.45 51.21,81.24 50.36,81.94 C 49.52,82.64 48.45,82.99 47.18,82.99 L 29.62,82.99 L 51.76,48.89 L 30.52,17.01 L 49.48,17.01 C 50.88,17.01 51.90,17.19 52.56,17.54 C 53.22,17.90 53.80,18.51 54.31,19.36 L 66.08,38.90 Z"/>
    <path fill="#000000" d="M 41.67,47.53 L 32.45,63.14 L 22.78,79.56 C 22.27,80.45 21.60,81.24 20.75,81.94 C 19.91,82.64 18.84,82.99 17.56,82.99 L 0.00,82.99 L 22.15,48.89 L 0.91,17.01 L 19.87,17.01 C 21.27,17.01 22.29,17.19 22.95,17.54 C 23.61,17.90 24.18,18.51 24.69,19.36 L 36.46,38.90 Z"/>
  </svg>
</template>

<script>
export default {
  name: 'ProjectLogo'
}
</script>
